import React from "react";
import {Box} from "@mui/material";
import {SxProps} from "@mui/system";
import {Theme} from "@mui/material/styles";
import {ReactComponent as PremiumSvg} from "../../assets/premium.svg";

type PremiumBadgeProps = {
  sx?: SxProps<Theme>
}

export default function PremiumBadge({sx}: PremiumBadgeProps): JSX.Element {
  return (
    <Box sx={{
      width: 24, height: 24, borderRadius: "50%", backgroundColor: "premium.main",
      display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0,
      ...sx
    }}>
      <PremiumSvg width="60%" height="60%" />
    </Box>
  );
}

